import { destroy } from 'redux-form';

export default function destroyForm(name) {
  return (dispatch) => dispatch(destroy(name));
}
